export default __webpack_public_path__ + "static/media/Conscript's Boots of Heaven's Pass.de732b6e.jpg";